import { Statement } from "@motley/design"

export default function Craftsmanship() {
  return (
    <section className="mx-auto max-w-140 px-6 pt-5 pb-10 sm:pt-10 sm:pb-20">
      <Statement sub="Complex underneath, simple on the outside, obsessively built for people who care about their craft.">
        The juggler makes impossible coordination look effortless.
        <br className="hidden sm:inline" /> That&apos;s what good tools do.
      </Statement>
    </section>
  )
}
